import { ref } from "vue";
import { useMutation } from "@tanstack/vue-query";
import { analyzeOrphanFiles, deleteOrphanFiles, } from "@erp/shared/api/generated/wrappers/system";
import { showAlert, showConfirm } from "@erp/shared/utils/dialog";
export const useOrphanFilesAction = () => {
    const orphanFiles = ref([]);
    const totalS3Files = ref(0);
    const referencedFiles = ref(0);
    const totalOrphanSize = ref(0);
    const isAnalyzing = ref(false);
    const selected = ref([]);
    const folderFilter = ref("");
    const hasMore = ref(false);
    const nextCursor = ref(null);
    const analyze = async () => {
        isAnalyzing.value = true;
        try {
            const result = await analyzeOrphanFiles();
            orphanFiles.value = result.orphanFiles;
            totalS3Files.value = result.totalS3Files;
            referencedFiles.value = result.referencedFiles;
            totalOrphanSize.value = result.totalOrphanSize;
            hasMore.value = result.hasMore;
            nextCursor.value = result.nextCursor;
            selected.value = [];
        }
        catch {
            showAlert("분석 중 오류가 발생했습니다.", "분석 실패");
        }
        finally {
            isAnalyzing.value = false;
        }
    };
    const loadMore = async () => {
        if (!hasMore.value || !nextCursor.value)
            return;
        isAnalyzing.value = true;
        try {
            const result = await analyzeOrphanFiles({
                cursor: nextCursor.value,
            });
            orphanFiles.value = [...orphanFiles.value, ...result.orphanFiles];
            hasMore.value = result.hasMore;
            nextCursor.value = result.nextCursor;
        }
        catch {
            showAlert("추가 데이터 로드 중 오류가 발생했습니다.", "로드 실패");
        }
        finally {
            isAnalyzing.value = false;
        }
    };
    const deleteMutation = useMutation({
        mutationFn: (keys) => deleteOrphanFiles(keys),
        onSuccess: (result) => {
            showAlert(`삭제 완료: ${result.deleted.length}건 성공, ${result.failed.length}건 실패`, "삭제 결과");
            // 삭제된 파일을 목록에서 제거
            const deletedSet = new Set(result.deleted);
            orphanFiles.value = orphanFiles.value.filter((f) => !deletedSet.has(f.key));
            selected.value = [];
        },
        onError: () => {
            showAlert("삭제 중 오류가 발생했습니다.", "삭제 실패");
        },
    });
    const deleteSelected = async () => {
        if (selected.value.length === 0) {
            showAlert("삭제할 파일을 선택해주세요.");
            return;
        }
        const confirmed = await showConfirm(`선택한 ${selected.value.length}개 파일을 삭제하시겠습니까?\n이 작업은 되돌릴 수 없습니다.`, "고아 파일 삭제");
        if (!confirmed)
            return;
        const keys = selected.value.map((f) => f.key);
        deleteMutation.mutate(keys);
    };
    return {
        orphanFiles,
        totalS3Files,
        referencedFiles,
        totalOrphanSize,
        isAnalyzing,
        selected,
        folderFilter,
        hasMore,
        analyze,
        loadMore,
        deleteSelected,
        isDeleting: deleteMutation.isPending,
    };
};
